<div class="container">
  <div class="calendar-container">
    <full-calendar #calendar [options]="calendarOptions">
      <!-- The code inside the ng-template is what's rendered inside the calendar event -->
      <ng-template #eventContent let-event>

        @let extendedProps = event.event.extendedProps;

        @let isAssigned = extendedProps.status === OpenHouseEventStatus.assigned;
        @let hasAgentRequests = (extendedProps.agentRequests || []).length !== 0;
        @let requiresApproval = extendedProps.requiresApproval;
        
        <div class="event-container" (click)="logEvent(event)">
          @if (mode === 'admin') {
            <!-- Admin only -->
            @if (isAssigned) {
              <div>
                <avatar
                  [imageURL]="extendedProps.agentImageURL"
                  [avatarName]="extendedProps.agentAvatarName"
                />
              </div>
            }
            @else if (hasAgentRequests && requiresApproval) {
              <div class="circle yellow-circle"></div>
            }
          } 
          @else {
            <!-- Agent only -->
            <div
              *ngIf="!isAssigned && extendedProps.isPending"
              class="circle"
              [ngClass]="extendedProps.didAgentRequestEvent ? 'yellow-circle' : 'green-circle'"
            ></div>
          }

          <div>{{ extendedProps.listingAddress }}</div>
          <div>{{ extendedProps.formattedShortStartEndDate }}</div>

        </div>
      </ng-template>
    </full-calendar>
  </div>
  <div class="timezone-container">
    <ion-icon name="cog-outline"></ion-icon>
    <ion-list class="timezone-select">
      <ion-select
        [(ngModel)]="selectedTimezone"
        (ionChange)="onTimezoneChange($event.target.value)"
        interface="popover"
        [interfaceOptions]="{cssClass: 'wide-timezone-option'}"
      >
        >
        <ion-select-option
          *ngFor="let timezone of TIMEZONES"
          [value]="timezone.value"
        >
          {{ timezone.display }}
        </ion-select-option>
      </ion-select>
    </ion-list>
  </div>
</div>
